export const PAGE_VIEW = 'PageView';
export const PAGE_UPGRADE = 'PageUpgrade';
export const SIGNUP = 'SignUp';
export const GA_EVENTS = {
  pageView: {
    category: 'pageview',
  },
  planUpgrade: {
    name: 'PlanUpgrade',
    category: 'Plan',
  },
  planUpgradeQualifiedCompany: {
    name: 'QualifiedCompanyPurchase',
    category: 'Plan',
  },
  planUpgradeQualifiedAgency: {
    name: 'QualifiedAgencyPurchase',
    category: 'Plan',
  },
  signUp: {
    name: 'CompletedSignup',
    category: 'SignUp',
  },
  signUpQualifiedCompany: {
    name: 'QualifiedCompanySignup',
    category: 'SignUp',
  },
  signUpQualifiedAgency: {
    name: 'QualifiedAgencySignup',
    category: 'SignUp',
  },
  submitLostLeadReportEmail: {
    name: 'SubmitLostLeadReportEmail',
  },
};

export const GA_CUSTOM_MAP = {};

export const IS_PROD_URL =
  window.location.host.indexOf('app.mobilemonkey.com') > -1;
